export interface RequestData {
  method: string;
  endpoint: string;
  token?: string | null;
  body?: object | null;
}

export interface FetchDataResponse<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

export enum AlertTypes {
  INFO = 'info',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'danger',
}

export interface TableData {
  id: number;
  [key: string]: any;
}

export interface Column {
  key: string;
  label: string;
  type: 'text' | 'number' | 'email';
}

export interface ActionButton {
  label: string;
  onClick: (row: TableData) => void;
}

export interface TableConfig {
  columns: Column[];
  actions: ActionButton[];
}
  